import * as React from 'react'
import { ReactElement } from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { generatePath } from 'react-router'
import { InheritablePropsWithChildren } from '../config/appConfig'

export type EntityPageProps = {
    // The route prefix, e.g. /file/:fileId
    routePrefix?: string
    useFileContext?: boolean
}

export type ParentProps = {
    route: string
    baseUrl: string
}

type Props = InheritablePropsWithChildren<ParentProps> & EntityPageProps & { baseUrl: string }

export default function EntityPage(props: Props): ReactElement {
    const match = useRouteMatch()

    // The dynamic route.
    const route: string = `${props.routePrefix || ''}${props.baseUrl}`
    const baseUrl: string = generatePath(route, match.params)

    return <Switch>{props.children({ route, baseUrl })}</Switch>
}
